import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import ProfileOrderHistorySection from '/component/partial/profile/ProfileOrderHistorySection';
import {withTranslation} from '/provider/TranslationProvider';
import {profileOrdersById} from '/redux/selector/client.selector';
import {currentScreen} from '/redux/selector/navigation.selector';
import {withHOC} from '/util/hoc.util';

export default withHOC(
  connect(
    createStructuredSelector({
      orders: profileOrdersById,
      currentScreen: currentScreen,
    }),
  ),
  withTranslation('screen.clientProfile.section.orderHistory'),
)(ProfileOrderHistorySection);
